import i18n from "i18next"
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Backend from 'i18next-http-backend';
import { initReactI18next } from "react-i18next"
import Modal from 'react-modal'
import { treaty } from "@elysiajs/eden"
import { App as Server } from 'rin-server/src/server'
import App from './App'
import './index.css'
import './components.css'
import { siteName } from './utils/constants'
import { listenSystemMode } from './utils/darkModeUtils'
import LanguageDetector from 'i18next-browser-languagedetector';

// Use Vite's environment variable format for the API URL
export const endpoint = import.meta.env.API_URL || 'http://localhost:12345'
export const oauth_url = `${endpoint}/user/github`
export const client = treaty<Server>(endpoint, {
  fetcher: (input, init = {}) => {
    return fetch(input, {
      ...init,
      credentials: 'include'
    })
  }
})



listenSystemMode()
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <title>{siteName}</title>
      </Helmet>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)
Modal.setAppElement('#root');